import { Monitor, Moon, Sun } from "lucide-react";
import {
  DocumentHeader,
  DocumentPage,
} from "@/components/shared/document-shell";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { Field, FieldGrid, FormSection } from "@/components/shared/form";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export function PreferencesSettingsPage() {
  return (
    <ErrorBoundary title="Preferences crashed">
      <PreferencesInner />
    </ErrorBoundary>
  );
}

function PreferencesInner() {
  const { theme, setTheme } = useTheme();

  return (
    <DocumentPage className="max-w-3xl">
      <DocumentHeader
        title="Preferences"
        subtitle="This browser only — stored locally, not synced to the server"
      />

      <FormSection id="appearance" title="Appearance" variant="plain" icon={<Monitor />}>
        <FieldGrid>
          <Field label="Theme" span={12}>
            <div className="inline-flex h-8 items-center gap-0.5 rounded-md border border-border bg-muted/50 p-0.5">
              {(
                [
                  ["light", "Light", Sun],
                  ["dark", "Dark", Moon],
                ] as const
              ).map(([value, label, Icon]) => (
                <Button
                  key={value}
                  type="button"
                  size="sm"
                  variant="ghost"
                  className={cn(
                    "h-7 gap-1.5 px-2.5 text-2xs",
                    theme === value && "bg-card font-medium shadow-sm",
                  )}
                  onClick={() => setTheme(value)}
                >
                  <Icon className="size-3.5" />
                  {label}
                </Button>
              ))}
            </div>
          </Field>
        </FieldGrid>
        <p className="mt-2 text-2xs text-muted-foreground">
          Same control as the top-bar theme toggle. Density and keyboard shortcuts follow the ERP
          shell defaults.
        </p>
      </FormSection>
    </DocumentPage>
  );
}
